import { localeReducer } from './locale';
import { screenReducer } from './screen';
import { userReducer } from './user';
import { routeReducer } from './route';
import type {
  ActiveFeatureConfigAction,
  CoBrandDetailsAction,
  CurrentVRCountryAction,
  GlobalContextAction,
  GlobalContextReducerState,
  LocaleAction,
  NavItemsAction,
  RouterAction,
  ScreenAction,
  UserAction
} from './types';
import { activeFeatureConfigReducer } from './activeFeatureConfig';
import { Portal } from '@dfg/brahma-types';
import { navItemsReducer } from './navItems';
import { currentVRCountryReducer } from './currentVRCountry';
import { coBrandDetailsReducer } from './coBrandDetails';

export const rootReducer = (
  {
    screen,
    locale,
    user,
    route,
    activeFeatureConfig,
    navItems,
    currentVRCountry,
    coBrandDetails
  }: GlobalContextReducerState,
  action: GlobalContextAction
): GlobalContextReducerState => ({
  screen: screenReducer(screen, action as ScreenAction),
  locale: localeReducer(locale, action as LocaleAction),
  user: userReducer(user, action as UserAction),
  route: routeReducer(route, action as RouterAction),
  activeFeatureConfig: activeFeatureConfigReducer(
    activeFeatureConfig,
    action as ActiveFeatureConfigAction
  ),
  navItems: navItemsReducer(navItems, action as NavItemsAction),
  portal: Portal.APPLICANT,
  currentVRCountry: currentVRCountryReducer(
    currentVRCountry ?? { name: '' },
    action as CurrentVRCountryAction
  ),
  coBrandDetails: coBrandDetailsReducer(
    coBrandDetails,
    action as CoBrandDetailsAction
  )
});
